const sluggify = (str) => {
  return str
    .replace(/^\s+|\s+$/g, '') // Trim leading/trailing white space
    .toLowerCase() // Convert string to lowercase
    .replace(/[^a-z0-9 -]/g, '') // Remove any non-alphanumeric characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-'); // Remove consecutive hyphens
};

const stripHtml = (str) => {
  if (!str) return '';

  return str
    .replace(/<[^>]*>/g, ' ') // Drop tags, leaving their content behind
    .replace(/&nbsp;/g, ' ') // Non-breaking spaces read as normal spaces
    .replace(/\s+/g, ' ') // Collapse the whitespace the tags left behind
    .trim();
};

export const useString = () => {
  return {
    sluggify,
    stripHtml,
  };
};
